import React from 'react';

type WCPageSectionProps = {
  /** Stable id for heading + aria (e.g. "wc26-fixtures") */
  sectionId: string;
  title: string;
  description?: string;
  children: React.ReactNode;
};

function WCPageSection({ sectionId, title, description, children }: WCPageSectionProps) {
  return (
    <section className="wc26-section" aria-labelledby={sectionId}>
      <div className="wc26-section-header">
        <h2 className="wc26-section-title" id={sectionId}>
          {title}
        </h2>
        {description ? <p className="wc26-section-desc">{description}</p> : null}
      </div>
      <div className="wc26-panel">{children}</div>
    </section>
  );
}

export default WCPageSection;
